import React, {useMemo} from "react";
import PostLoginHandler from "../handler/PostLoginHandler";
import {AccountSettings} from "../accountSettings/AccountSettings";

export default function AccountSettingsRoute(props) {

    const pendingOperation = useMemo(() => {
        const data = sessionStorage.getItem("pendingOperation");
        return data ? JSON.parse(data) : null;
    }, []);


    if (pendingOperation) {
        return <PostLoginHandler {...props} />;
    }

    return <AccountSettings {...props} />;
}